// extracted by mini-css-extract-plugin
module.exports = {"confetti":"Confetties_confetti__1gyQi"};